export const authenticateViaApikey = ({ graphqlEndpoint, apiKey }) =>
  fetch(graphqlEndpoint, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': apiKey,
      'orion-audit-originator': 'LUMENITE'
    },
    body: JSON.stringify({
      query: 'query IntrospectionQuery { __schema { queryType { name } } }',
    }),
  }).then(response => response.json());

export const authenticateViaLambda = ({ graphqlEndpoint, authorizationToken }) =>
  fetch(graphqlEndpoint, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': authorizationToken,
      'orion-audit-originator': 'LUMENITE'
    },
    body: JSON.stringify({
      query: 'query IntrospectionQuery { __schema { queryType { name } } }',
    }),
  }).then(response => response.json());

export const fetchIntrospectionQuery = ({ graphqlEndpoint, apiKey, token, graphQLParams, requestHeaders, rsaSignature }) => {
  const authorization = {};
  if (apiKey) authorization['x-api-key'] = apiKey;
  if (token) authorization.authorization = token;

  return fetch(graphqlEndpoint, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'orion-audit-originator': 'LUMENITE',
      'x-signature': rsaSignature,
      ...authorization,
      ...requestHeaders,
    },
    body: JSON.stringify(graphQLParams),
  }).then(response => response.json());
};
